import { render, staticRenderFns } from "./DrawerMenuItem.vue?vue&type=template&id=a2277e4a&scoped=true"
import script from "./DrawerMenuItem.vue?vue&type=script&setup=true&lang=js"
export * from "./DrawerMenuItem.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DrawerMenuItem.vue?vue&type=style&index=0&id=a2277e4a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2277e4a",
  null
  
)

export default component.exports